import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { baseUrl } from '../../../config/baseUrl';
import { toast } from 'react-toastify';
import chemicalbg from "../../../assets/images/chemical-bg.png";
const AddSubCatgory = ({setApiCall,setLoader}) => {
    let loginUser = JSON.parse(localStorage.getItem("user"));
    const [catList, setCatList] = useState([]);
    const [depoList, setDepoList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("");
    const [previewUrl, setPreviewUrl] = useState(null);
    const [values, setValues] = useState({
        depo: [],
        subcategory_name: "",
    })
    console.log(values)
    const [pdfFile, setPdfFile] = useState(null)
    const [imgFile, setImgFile] = useState(null)

    const handleChange = (e,depoQ) => {
        const { name, value } = e.target;
        if (name === "depo") {
            return setValues((curval) => {
                let id = parseInt(value);
                if (curval.depo.some(item => item.depo === id)) {
                    let data = curval.depo.filter((item) => item.depo !== id);
                    return { ...curval, [name]: data };
                }
                return {
                    ...curval,
                    [name]: [...curval.depo, {"depo":parseInt(value),"q":""}],
                };
            });
        }else if(depoQ){
            return setValues((curval) => {
                let id=parseInt(name.split("-").pop())
                if (curval.depo.some(item => item.depo === id)) {
                    let data = curval.depo.map((item) => {
                    if(item.depo == id){
                        return { ...item, q: value };
                    }
                    return item
                    });
                    return { ...curval, depo:  data  };
                }
                return {
                    ...curval,
                    depo: [...curval.depo , {"depo":id,"q":value}],
                };

            });
        } else {
            setValues(prevValues => ({
                ...prevValues,
                [name]: value
            }));
        }
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("inner", values)

        if ( !values.subcategory_name) {
            toast.error('Chemical Name required');
            return;
        }
        if (!pdfFile) {
           return toast.error("pdfFile required")
        }
        if (!imgFile) {
            return toast.error("image required")
        }
        if (!values?.depo.length) {
            return  toast.error("depo is required")
        }

      for (let index = 0; index < values?.depo.length; index++) {
        const element = values?.depo[index];
        if(!element.depo){
            return  toast.error("Please select depo")
        }
        if(!element.q){
            return  toast.error("Please enter depo quantity")
        }

      }
        try {
            const formData = new FormData();
            formData.append('depo', JSON.stringify(values.depo))
            formData.append('subcategory_name', values.subcategory_name)

            if (pdfFile) {
                formData.append('subcategory_document', pdfFile)
            }
            if (imgFile) {
                formData.append('subcategory_images', imgFile)
            }

            let unique = document.getElementById("unique");
            unique.click();

            setLoader(true)
            const res = await axios.post(`${baseUrl}/module/admin/subcategory-viewset`, formData, {
                headers: {
                    Authorization: "Token " + localStorage.getItem("token"),
                },
            })
            if (res.data.code === 200) {
                toast.success(res.data.message)
                setApiCall(Math.random());
                setValues({
                    depo: [],
                    subcategory_name: "",
                });
                setImgFile("")
                setPdfFile("")
            } else {
                setApiCall(Math.random());
                toast.error(res.data.message)
            }
        } catch (error) {
            toast.error(error.response)
            console.log("error role permission", error)
        }
    }

    const fetchDepo = async () => {
        try {
            let url = `${baseUrl}/module/admin/depo-list`;
            if (loginUser?.user_type === "SUPER_ADMIN" && selectedCompany) {
                url += `?company=${selectedCompany}`;
            }
            const res = await axios.get(url, {
                headers: {
                    Authorization: "Token " + localStorage.getItem("token"),
                },
            })
            setDepoList(res.data.data)
        } catch (error) {
            console.log("fetch depo error", error)
        }
    }

    useEffect(() => {
        fetchDepo();
    }, [selectedCompany])


    return (
        <>
            <div
                className="modal fade custom-modal addbus-modal"
                id="addbus2"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header justify-content-center">
                            <h5 className="modal-title" id="">
                                Add Chemical
                            </h5>
                            <button
                                type="button"
                                className="modal-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="unique"
                                onClick={() => {
                                    setValues({
                                      depo: [],
                                      subcategory_name: "",
                                    });
                                    setImgFile("")
                                    setPdfFile("")
                                    setSelectedCompany("")
                                  }}
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-5 text-center">
                                    <div className="addbus-modal-innr">
                                        <img src={chemicalbg} alt="" />
                                        <form action="" onSubmit={handleSubmit}>
                                            <div className="row justify-content-center">
                                                <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                                                    <label style={{ fontWeight: 500, marginBottom: 6 }}>Select Depo</label>
                                                    <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: 4, padding: 8 }}>
                                                        {depoList?.map((arr, i) => {
                                                            const isSelected = values?.depo?.some(
                                                                item => item.depo == arr?.id
                                                            );
                                                            const selectedDepo = values?.depo?.find(
                                                                item => item.depo == arr?.id
                                                            );
                                                            return (
                                                                <div
                                                                    key={arr?.id}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "16px",
                                                                        width: "100%",
                                                                        marginBottom: 8,
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        name="depo"
                                                                        checked={isSelected}
                                                                        value={arr.id}
                                                                        onChange={handleChange}
                                                                        style={{ marginRight: 4 }}
                                                                    />
                                                                    <div style={{ minWidth: 160, fontWeight: 500 }}>
                                                                        {arr?.depo_name}
                                                                    </div>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        style={{ width: 100, marginLeft: 0, marginRight: 0 }}
                                                                        name={`q-${arr?.id}`}
                                                                        value={selectedDepo?.q || ""}
                                                                        min={0}
                                                                        onChange={(e) => handleChange(e, "depoQ")}
                                                                        disabled={!isSelected}
                                                                        required={isSelected}
                                                                        placeholder="Qty"
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                        {depoList?.length === 0 && (
                                                            <div className="text-muted">
                                                                No depot found
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="frm-bx mb-4 col-lg-8 text-start">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Chemical Name"
                                                        name="subcategory_name"
                                                        value={values?.subcategory_name}
                                                        onChange={handleChange}
                                                    />

                                                    <span className="fa fa-server icon" />
                                                </div>
                                                <div className="frm-bx mb-4 col-lg-8 text-start upload-bx">
                                                        <label>Add PDF</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept=".pdf,.doc,.docx"
                                                        onChange={(e) => setPdfFile(e.target.files[0])}
                                                    />
                                                     { pdfFile &&  <div className="col-lg-4"><iframe src={URL.createObjectURL(pdfFile)}  width="180" height="100" id="pdfFrame"></iframe></div>}
                                                </div>
                                                <div className="frm-bx mb-4 col-lg-8 text-start upload-bx">
                                                        <label>image</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept="image/png"
                                                        onChange={(e) => setImgFile(e.target.files[0])}
                                                    />
                                                     { imgFile  &&  <div className="col-lg-4"><img src={URL.createObjectURL(imgFile)}  width="180" height="100" id="pdfFrame"></img></div> }
                                                </div>
                                                <div className="frm-bx mb-4 col-lg-8 mb-3">
                                                    <button className="thm-btn" type="submit">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddSubCatgory
